import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IProductGroup} from "../product-models";
import {BaseComponent} from "../../base.component";
import {UserService} from "../../common/user.service";
import {LoggerService} from "../../common/logger.service";

@Component({
    selector: 'app-product-drawer',
    templateUrl: './product-drawer.component.html',
    styleUrls: ['./product-drawer.component.scss', '../product.scss'],
    standalone: false
})
export class ProductDrawerComponent extends BaseComponent {
    @Input() productGroup: IProductGroup;
    @Input() showDrawer = false;
    @Input() showProduct = true;
    @Output() readonly openClose = new EventEmitter();

    constructor(userService: UserService, loggerService: LoggerService) {
       super(userService, loggerService);
    }
}
